import {
  OIDC_CLIENT_ID,
  OIDC_REDIRECT_PATH,
  OIDC_SCOPE,
  OIDC_UI_LOCALES,
} from '@/auth/constants';
import type { UserManagerSettings } from 'oidc-client-ts';
import { WebStorageStateStore } from 'oidc-client-ts';

const DISCOVERY_SUFFIX = '/.well-known/openid-configuration';
const OIDC_POST_LOGOUT_PATH = '/redirect.html';

export const hasReturnedFromLogout = (): boolean =>
  window.location.pathname === OIDC_POST_LOGOUT_PATH &&
  !new URLSearchParams(window.location.search).has('code');

const toAuthority = (discoveryUrl: string): string =>
  discoveryUrl.endsWith(DISCOVERY_SUFFIX)
    ? discoveryUrl.slice(0, -DISCOVERY_SUFFIX.length)
    : discoveryUrl;

export const buildOidcConfig = (discoveryUrl: string): UserManagerSettings => {
  const redirectUri = `${window.location.origin}${OIDC_REDIRECT_PATH}`;

  return {
    authority: toAuthority(discoveryUrl),
    metadataUrl: discoveryUrl,
    client_id: OIDC_CLIENT_ID,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: `${window.location.origin}${OIDC_POST_LOGOUT_PATH}`,
    response_type: 'code',
    scope: OIDC_SCOPE,
    ui_locales: OIDC_UI_LOCALES,
    automaticSilentRenew: false,
    loadUserInfo: false,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  };
};
